"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EASE_OUT_CUBIC = function (t) { return (--t) * t * t + 1; };
exports.EASE_OUT_CUBIC = EASE_OUT_CUBIC;
//# sourceMappingURL=Easing.js.map